export const FETCH_PARTNER_ORDERS_REQUEST = 'FETCH_PARTNER_ORDERS_REQUEST';
export const FETCH_PARTNER_ORDERS_RESPONSE = 'FETCH_PARTNER_ORDERS_RESPONSE';

export const fetchPartnerOrdersRequest = (data) => {
    return {
        type: FETCH_PARTNER_ORDERS_REQUEST,
        data
    }
}
export const fetchPartnerOrdersResponse = (data) => {
    return {
        type: FETCH_PARTNER_ORDERS_RESPONSE,
        data
    }
}